import Button from '@jetbrains/ring-ui/components/button/button'
import Confirm from '@jetbrains/ring-ui/components/confirm/confirm'
import Toggle from '@jetbrains/ring-ui/components/toggle/toggle'
import * as React from 'react'

import type {HolderType, PolicyEntry} from '../../CleanupProjectPage.types'
import styles from '../Rules/RulesList/RuleItem/RuleItem.css'

type OwnProps = {
  onResetClick: (() => unknown) | null | undefined
  onPolicyDisable: (arg0: boolean) => unknown
  onEditClick: (arg0: any) => any
  type: HolderType
  className: string
  policy: PolicyEntry
}

function ActionsSection({
  className,
  policy,
  onPolicyDisable,
  onResetClick,
  onEditClick,
  type,
}: OwnProps) {
  const [showConfirmPopup, setShowConfirmPopup] = React.useState(false)
  const [showResetPopup, setShowResetPopup] = React.useState(false)
  const policiesEnabled = Boolean(!policy.options.cleanupPoliciesDisabled)
  const hideDisableConfirmation = React.useCallback(() => setShowConfirmPopup(false), [])
  const toggleDisableState = React.useCallback(() => {
    if (!policiesEnabled) {
      onPolicyDisable(false)
      return
    }

    setShowConfirmPopup(true)
  }, [policiesEnabled, onPolicyDisable])
  const confirmSetDisable = React.useCallback(() => {
    onPolicyDisable(policiesEnabled || false)
    setShowConfirmPopup(false)
  }, [policiesEnabled, onPolicyDisable])
  const toggleResetConfirm = React.useCallback(() => setShowResetPopup(state => !state), [])
  const onResetConfirm = React.useCallback(() => {
    if (!onResetClick) {
      return
    }

    onResetClick()
    toggleResetConfirm()
  }, [onResetClick, toggleResetConfirm])
  const showToggler = type !== 'template'
  return (
    <div className={className}>
      <Button text onClick={onEditClick} className={styles.actionButton}>
        {'Edit'}
      </Button>
      {onResetClick && (
        <>
          <Button text danger onClick={toggleResetConfirm} className={styles.actionButton}>
            {'Reset'}
          </Button>
          <Confirm
            show={showResetPopup}
            text={`Reset base rule`}
            description={
              'You are about to\u00a0reset the\u00a0current Base\u00a0rule definition and use the\u00a0rule inherited from\u00a0the\u00a0parent\u00a0project instead.'
            }
            onConfirm={onResetConfirm}
            onReject={toggleResetConfirm}
          />
        </>
      )}
      {showToggler && (
        <>
          <Toggle
            className={styles.inheritanceToggle}
            checked={policiesEnabled}
            onChange={toggleDisableState}
          />
          <Confirm
            show={showConfirmPopup}
            text="Disable base rule"
            description={
              <>
                {type === 'project'
                  ? `
                    You are about to\u00a0disable a\u00a0base\u00a0rule for\u00a0this\u00a0project.
                    Note that it will be also disabled in\u00a0all its\u00a0subprojects and build\u00a0configurations.
                  `
                  : 'You are about to\u00a0disable a\u00a0base rule for\u00a0this build\u00a0configuration.'}
                {
                  ' Before proceeding, make sure that all valuable\u00a0data is preserved by\u00a0keep\u00a0rules.'
                }
                <br />
                {'Click OK to\u00a0disable the\u00a0base\u00a0rule.'}
              </>
            }
            onConfirm={confirmSetDisable}
            onReject={hideDisableConfirmation}
          />
        </>
      )}
    </div>
  )
}

export default ActionsSection
